<script setup lang="ts">
import './assets/style.scss'
import type { PropType } from 'vue'
import type { InventoryStatsType } from '@/entities/Inventory/Main'

const props = defineProps({
  stats: {
    type: Object as PropType<InventoryStatsType>,
    required: true,
  },
  hideBtn: {
    type: Boolean,
    default: false,
  },
})

const emits = defineEmits(['selectChildren'])

/**
 * Обработка клика по элементу подсчета
 * @param childIds
 */
const clickHandler = (childIds: number[]) => {
  emits('selectChildren', childIds)
}

/**
 * Функция выделения всех объектов
 */
const selectAllHandler = () => {
  if (!props.stats) return

  let ids: number[] = []

  Object.values(props.stats.by_type).forEach((item: any) => {
    ids = [...ids, ...item.object_ids]
  })

  emits('selectChildren', ids)
}
</script>

<template>
  <div class="invent-stats__header mt-4">
    <p>{{ $t('itf.summary_info') }}</p>

    <VBtn v-if="!hideBtn" density="compact" @click.prevent="selectAllHandler">{{
      $t('itf.all_elements')
    }}</VBtn>
  </div>

  <div class="invent-stats__grid">
    <div class="invent-stats__block" v-for="(value, key) in stats.value" :key>
      <div class="invent-stats__header">
        {{ key }}
        <span>{{ Math.round(value) }} {{ $t(`itf.${stats.unit[key]}`) }}</span>
      </div>

      <template v-if="stats.by_type[key]?.subtypes">
        <div class="invent-stats__row" v-for="(subValue, subKey) in stats.by_type[key].subtypes">
          <a href="#" @click.prevent="clickHandler(subValue.ids)">{{ subKey }}:</a>

          <span>
            {{ subValue.count || Math.round(subValue.meters) }}
            {{ $t(`itf.${stats.unit[key]}`) }}
          </span>
        </div>
      </template>
    </div>
  </div>
</template>
